// Pinta la marca SOBRE una copia de la imagen, para que la visión la vea
// (ADR-2026-09-21-el-marcador-de-la-mezcla): los mismos trazos que se ven en el lienzo,
// en rojo semitransparente, con el pincel a escala de la imagen. Sólo la copia pintada
// viaja a la visión; el generador recibe siempre la imagen limpia. DOM puro (fetch +
// canvas), sin React.

import type { Marca } from './marcador';

export const COLOR_DE_MARCA = '#FF2D2D';
export const ALPHA_DE_MARCA = 0.45;

/** Dibuja los trazos de una marca en un contexto ya escalado a `ancho` × `alto` píxeles. */
export function pintarMarca(ctx: CanvasRenderingContext2D, marca: Marca, ancho: number, alto: number): void {
  ctx.save();
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.strokeStyle = COLOR_DE_MARCA;
  ctx.globalAlpha = ALPHA_DE_MARCA;
  ctx.lineWidth = Math.max(2, marca.grosor * Math.min(ancho, alto));
  for (const trazo of marca.trazos) {
    if (trazo.length === 0) continue;
    ctx.beginPath();
    ctx.moveTo(trazo[0].x * ancho, trazo[0].y * alto);
    if (trazo.length === 1) ctx.lineTo(trazo[0].x * ancho + 0.01, trazo[0].y * alto);
    for (let i = 1; i < trazo.length; i++) ctx.lineTo(trazo[i].x * ancho, trazo[i].y * alto);
    ctx.stroke();
  }
  ctx.restore();
}

export async function imagenConMarca(url: string, marca: Marca): Promise<File> {
  const res = await fetch(url);
  if (!res.ok) throw new Error('No se pudo leer la imagen para marcarla.');
  const bitmap = await createImageBitmap(await res.blob());
  try {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('No se pudo pintar la marca.');
    ctx.drawImage(bitmap, 0, 0);
    pintarMarca(ctx, marca, bitmap.width, bitmap.height);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
    if (!blob) throw new Error('No se pudo pintar la marca.');
    return new File([blob], 'marca.jpg', { type: 'image/jpeg' });
  } finally {
    bitmap.close();
  }
}
